import { render } from "./SubjectOccupiedCounters.vue?vue&type=template&id=d66c19c2"
import script from "./SubjectOccupiedCounters.vue?vue&type=script&lang=js"
export * from "./SubjectOccupiedCounters.vue?vue&type=script&lang=js"
script.render = render

export default script